import './shared'
import i18n from 'live/services/i18n'
import { en_us, pt_br } from './i18n'
import locale from 'live/init/global-locale'
const localeFiles = { pt_br, en_us }

try {
    i18n.add(localeFiles[locale])
} catch (error) {
    console.log(error)
}
